function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import GlobalImports from '../layout/shared/GlobalImports';
import TrackersInit from '../layout/shared/TrackersInit';
import FlashMessage from './FlashMessage';
import MobileNavigation from '../layout/header/navigations/MobileNavigation';
var PageContent = function PageContent() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '50vh'
    }
  });
}; // can be a layout
var PageComponent = function PageComponent() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '50vh'
    }
  });
}; // the content of the layout when PageContent is a layout
var Header = function Header() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '10vh'
    }
  });
};
var Footer = function Footer() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '10vh'
    }
  });
};
export default function App(props) {
  var appProps = props.appProps,
    componentPath = props.componentPath,
    packageComponent = props.packageComponent,
    errorScreen = props.errorScreen,
    renderThroughLayout = props.renderThroughLayout;
  var _useState = useState(appProps),
    _useState2 = _slicedToArray(_useState, 2),
    currentAppProps = _useState2[0],
    _setCurrentAppProps = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    renderKey = _useState4[0],
    setRenderKey = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    showHeader = _useState6[0],
    setShowHeader = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    showFooter = _useState8[0],
    setShowFooter = _useState8[1];
  var currentAppPropsRef = useRef(currentAppProps);
  var flashMessageRef = useRef(null);
  var updatedAppProps = _objectSpread(_objectSpread({}, currentAppPropsRef.current), {}, {
    setCurrentAppProps: setCurrentAppProps,
    flashMessage: flashMessageRef && flashMessageRef.current,
    setShowHeader: setShowHeader,
    setShowFooter: setShowFooter
  });
  useEffect(function () {
    Header = /*#__PURE__*/lazy(function () {
      return import("../layout/header/Header_v".concat(currentAppPropsRef.current.headerVersion));
    });
    Footer = /*#__PURE__*/lazy(function () {
      return import("../layout/footer/Footer_v".concat(currentAppPropsRef.current.footerVersion));
    });
  }, []);
  useEffect(function () {
    if (packageComponent) {
      PageContent = /*#__PURE__*/lazy(function () {
        return import("../".concat(componentPath));
      });
      if (renderThroughLayout) {
        PageComponent = props.PageContent;
      }
    } else {
      PageContent = props.PageContent;
    }
    setTimeout(function () {
      return setRenderKey(Math.random());
    }, 100);
  }, [props.PageContent]);
  function setCurrentAppProps(state) {
    _setCurrentAppProps(function (prevState) {
      var updatedState = _objectSpread(_objectSpread({}, prevState), state);
      currentAppPropsRef.current = updatedState;
      return updatedState;
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "outer-container"
  }, /*#__PURE__*/React.createElement(TrackersInit, {
    appProps: updatedAppProps
  }), /*#__PURE__*/React.createElement(GlobalImports, {
    appProps: updatedAppProps
  }), /*#__PURE__*/React.createElement(FlashMessage, {
    ref: flashMessageRef
  }), appProps.navigation.mobile_menu && appProps.currentDevice != 'desktop' && currentAppPropsRef.current.headerVersion != 4 && /*#__PURE__*/React.createElement(MobileNavigation, {
    className: 'burger-menu',
    appProps: appProps,
    navigation: appProps.navigation.mobile_menu
  }), currentAppPropsRef.current.headerVersion == 4 && /*#__PURE__*/React.createElement(MobileNavigation, {
    className: 'burger-menu',
    appProps: appProps,
    navigation: appProps.currentDevice != 'desktop' ? appProps.navigation.mobile_menu : appProps.navigation.header_menu
  }), /*#__PURE__*/React.createElement("main", {
    id: "page-wrap"
  }, showHeader && !props.errorScreen && /*#__PURE__*/React.createElement(Suspense, {
    key: "".concat(renderKey, "_header"),
    fallback: /*#__PURE__*/React.createElement("div", null)
  }, /*#__PURE__*/React.createElement(Header, {
    appProps: updatedAppProps
  })), /*#__PURE__*/React.createElement(Suspense, {
    key: "".concat(renderKey, "_content"),
    fallback: /*#__PURE__*/React.createElement("div", null)
  }, packageComponent && renderThroughLayout && /*#__PURE__*/React.createElement(PageComponent, Object.assign({}, props, {
    appProps: updatedAppProps,
    Component: PageContent
  })), !(packageComponent && renderThroughLayout) && /*#__PURE__*/React.createElement(PageContent, Object.assign({}, props, {
    appProps: updatedAppProps
  }))), showFooter && /*#__PURE__*/React.createElement(Suspense, {
    key: "".concat(renderKey, "_footer"),
    fallback: /*#__PURE__*/React.createElement("div", null)
  }, /*#__PURE__*/React.createElement(Footer, {
    appProps: updatedAppProps,
    errorScreen: props.errorScreen
  }))));
}